var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-gdrp-notification-wrapper"},[_c('asc-notification',{staticClass:"asc-gdrp-notification-wrapper",attrs:{"definition":_vm.definition,"on-close":_vm.handleClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }